<template>
	<b-row>
		<b-col></b-col>
		<b-col cols="5">
			<div class="card">
				<div class="card-body">
					<!-- div class="col-md-12" -->
					<b-alert 
						:variant="alert.type"
						dismissible
						fade
						:show="alert.show"
					>
					{{ alert.message }}
					</b-alert>
					<div class="row mb-2 mr-1">
						<div class="col-md-10">
							<h3>Shippingservice-Preselection-Gruppen</h3>
						</div>
						<div class="col-md-2 pr-0">
						<b-button size="sm" @click="modalGroupEdit.open()" class="float-right"><span class="icon icon-plus"></span></b-button>
						</div>
					</div>
					<b-table v-if="groups" :items="groups" :fields="tableConfig.fields" ref="refGroupTable" size="sm" striped hover small>
						<template v-slot:cell(actions)="row">
							<b-button size="sm" @click="modalGroupEdit.open(row.item)" class="float-right py-0 my-0 px-1"><span class="icon icon-pencil"></span></b-button>
						</template>
					</b-table>
					<b-modal id="modal-1" size="lg" title="Gruppe Bearbeiten" v-model="modalGroupEdit.state" style="width:900px!important">
						<b-form-group
							v-if="modalGroupEdit.group"
							label-cols-sm="4"
							label-cols-lg="2"
							label="Name"
							label-for="input-modal-group-edit-name"
						>
							<b-form-input  id="input-modal-group-edit-name"  v-model="modalGroupEdit.group.name"></b-form-input>
						</b-form-group>
						<b-table v-if="modalGroupEdit.group  && ((modalGroupEdit.group.countries)  && (modalGroupEdit.group.countries.length > 0))" :items="modalGroupEdit.group.countries" :fields="modalGroupEdit.countryTableConfig.fields" striped hover />
						<template v-slot:modal-footer="{  }">
						
							<b-button size="sm" variant="secondary" @click="modalGroupEdit.confirm()">
								Speichern
							</b-button>
							<b-button size="sm" variant="outline-secondary" @click="modalGroupEdit.cancel()">
								Abbrechen
							</b-button>
						</template>
					</b-modal>
				</div>
			</div>
		</b-col>
		<b-col></b-col>
	</b-row>
	<!-- /div -->
</template>

<script>
export default {
	props: [ ],
	data() { return {
		groups: [],
		alert: {
			show: false,
			type: "warning",
			message: "no alert message set",
			set: function(type, message) {
				this.show = true;
				this.type = type;
				this.message = message;
			}
		},
		tableConfig: { 
			fields: [
				{ key: 'name', label: 'Gruppen-Name' },
				{ key: 'actions', label: '' }
			],
		},
		modalGroupEdit: {
			piss: this,
			state: false,
			group: null,
			countryTableConfig: {
				fields: [
					{ key: 'countryName', label: 'Name' },
					{ key: 'countryIso', label: 'ISO' }
				]
			},
			open(group = null) {
				if(group === null) {
					this.group =  { name: "", countries: [ ] }
				}else{
					this.group = group;
				}
				this.state = true;
				//this.piss.modalGroupEditState = true;
			},
			confirm() {
				axios.post('/shippingservicepreselectiongroup/save', this.group )
				.then((response) => {
					this.piss.alert.set("success", "Speichervorgang war erfolgreich");
					this.state = false;
					if('id' in this.group) {
						this.group = response.data;
					}else{
						location.reload();
						// this.piss.groups.push(response.data);
						// this.$refs.refGroupTable.refreshTable();
						// this.piss.$forceUpdate();
					}
					this.state = false;
					//this.piss.modalGroupEditState = false;
				})
				.catch((error) => {
					this.piss.alert.set("danger", "Änderungen wurden aufgrund eines Fehlers nicht gespeichert.");
					this.state = true;
					//this.piss.modalGroupEditState = true;
				});
			},
			cancel() {
				this.group = null;
				this.state = false;
				//this.piss.modalGroupEditState = false;
			}
		},
		modalGroupEditState: false
	} },
	methods: { },
	created() {
		axios.get('/shippingservicepreselectiongroup/groups')
		.then((response) => {
			this.groups = response.data;
		}).catch((error) => {
			this.piss.alert.set("danger", "Gruppen konnten nicht vom Server abgerufen werden.");
		});
	}
}
</script>
